import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { useFormField } from 'sb-hooks'
import actions from 'redux/actions'
import { FormattedMessage } from 'sb-react-intl'

import RatingStars from 'components/rating/RatingStars/RatingStars'

import messages from './messages'
import s from './SelectRating.scss'


const SelectRating = ({ className, field, count, withNumbers }) => {
  const { value, error } = useFormField(field)

  const labelClassName = cx(s.label, {
    [s.error]: error,
  })

  return (
    <div className={cx(s.ratingContainer, className)}>
      <FormattedMessage className={labelClassName} {...messages.label} />
      <RatingStars
        className={s.rating}
        lg
        withNumbers={withNumbers}
        count={count}
        value={value}
        onClick={(num) => {
          field.set(num)
          actions.models.review.setProductRating(num)
        }}
      />
      <FormattedMessage className={s.hint} {...messages.hint} />
    </div>
  )
}

SelectRating.propTypes = {
  className: PropTypes.string,
  field: PropTypes.object.isRequired,
  count: PropTypes.number,
  withNumbers: PropTypes.bool,
}


export default SelectRating
